import { CognitoUserPool } from 'amazon-cognito-identity-js'

import { environment } from '@auth-portal/environment'

// Dev User Pool
export const Pool = new CognitoUserPool({
  UserPoolId: environment.cognito.AWS_USERPOOL_ID,
  ClientId: environment.cognito.AWS_CLIENT_ID,
})
